import { connect } from 'react-redux';
import BidSelectorWizard from 'components/bids/BidSelectorWizard';
import { fetchGarage, clearGaragesData } from 'data/garages/Garages.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    fetchingGarage: state.garages.fetchingGarage,
    garage: state.garages.currentGarage,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchGarage: garageId => dispatch(fetchGarage(garageId)),
    clearGarage: () => dispatch(clearGaragesData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BidSelectorWizard);
